module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back-all",
    staticStyle: {
      "padding-bottom": "3rem"
    }
  }, [_c('NavFloatShare', {
    on: {
      "show": function($event) {
        _vm.show_share_panel = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "map-header"
  }, [_c('div', {
    staticClass: "map-time"
  }, [_vm._l((_vm.weeks), function(week, i) {
    return _c('div', {
      key: i,
      staticClass: "daybox"
    }, [_c('div', {
      staticClass: "weeks-title"
    }, [_vm._v(_vm._s(week))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "map-time",
    style: (_vm.overlayShow ? 'height: 5rem' : ''),
    on: {
      "touchmove": _vm.btnMove,
      "touchstart": _vm.btnStart,
      "touchend": _vm.btnEnd
    }
  }, _vm._l((_vm.weekdays), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "daybox month-box"
    }, [_c('span', {
      class: i == _vm.dayIndex ? 'action weeks-title' : ' weeks-title',
      on: {
        "click": function($event) {
          return _vm.weekDay(item, i)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.day))]), _vm._v(" "), _vm._l((_vm.list), function(month, m) {
      return (month.title == item.year_title) ? _c('div', {
        staticClass: "solid-box-flex"
      }, _vm._l((_vm.range_list), function(range, key) {
        return (item.year_times <= range[1] && range[0] <= item.year_times) ? _c('div', {
          staticClass: "solid-days",
          style: ('background:#' + range[2][0])
        }, [_c('span', {
          staticStyle: {
            "color": "#fff"
          }
        }, [_vm._v(_vm._s(item.day))])]) : _vm._e()
      }), 0) : _vm._e()
    })], 2)])
  }), 0)], 2), _vm._v(" "), (!_vm.arrow) ? _c('div', {
    staticClass: "year-month"
  }, [_c('span', {
    staticClass: "year-left-btn",
    on: {
      "click": _vm.timeDownBtn
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "width": "48px"
    },
    attrs: {
      "src": require("../../../assets/images/icon-data-left.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "0 20px"
    }
  }, [_vm._v(_vm._s(_vm.yearMonth.year_month))]), _vm._v(" "), _c('span', {
    staticClass: "year-right-btn",
    on: {
      "click": _vm.timeUpBtn
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "width": "48px"
    },
    attrs: {
      "src": require("../../../assets/images/icon-data-right.png"),
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.arrow) ? _c('div', {
    staticClass: "onday-sai"
  }, _vm._l((_vm.daySaiList), function(item) {
    return _c('div', {
      staticClass: "sai-itmes",
      staticStyle: {
        "background": "#f5f5f5",
        "border-radius": "5px"
      }
    }, [_c('div', {
      staticClass: "items-top1"
    }, [_c('div', {
      staticClass: "train-items-top show-two-row ",
      style: ('background-image: linear-gradient(to right, #' + item.color[0] + ' , #' + item.color[1] + ');')
    }, [(item.is_online == 1) ? _c('div', {
      staticClass: "sai-type-tip"
    }, [_vm._v("线上")]) : (item.is_online == 2) ? _c('div', {
      staticClass: "sai-type-tip offline"
    }, [_vm._v("线下")]) : _c('div', {
      staticClass: "sai-type-tip offline2"
    }, [_vm._v("线上线下结合")]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-city"
    }, [_vm._v(_vm._s(item.location))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-time"
    }, [_vm._v(_vm._s(item.saidate_str) + " ~ " + _vm._s(item.saidate_end_str))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center",
        "margin-top": ".1rem"
      }
    }, [(item.status == 1) ? _c('span', {
      staticClass: "info-status-0"
    }, [_vm._v("未开始")]) : (item.status == 2) ? _c('span', {
      staticClass: "info-status-1"
    }, [_vm._v("正在报名")]) : (item.status == 3) ? _c('span', {
      staticClass: "info-status-0"
    }, [_vm._v("报名结束")]) : (item.status == 4) ? _c('span', {
      staticClass: "info-status-1"
    }, [_vm._v("正在比赛")]) : (item.status == 5) ? _c('span', {
      staticClass: "info-status-0"
    }, [_vm._v("已结束")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "sai-info-box",
      staticStyle: {
        "flex": "1"
      }
    }, [_c('p', {
      staticClass: "sai-title show-two-row"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (false) ? _c('div', {
      staticClass: "sai-info"
    }, [(item.status == 1) ? _c('span', {
      staticClass: "info-status-0"
    }, [_vm._v("·未开始")]) : (item.status == 2) ? _c('span', {
      staticClass: "info-status-1"
    }, [_vm._v("·正在报名")]) : (item.status == 3) ? _c('span', {
      staticClass: "info-status-0"
    }, [_vm._v("·报名结束")]) : (item.status == 4) ? _c('span', {
      staticClass: "info-status-1"
    }, [_vm._v("·正在比赛")]) : (item.status == 5) ? _c('span', {
      staticClass: "info-status-0"
    }, [_vm._v("·已结束")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "sai-info"
    }), _vm._v(" "), _c('div', {
      staticClass: "items-btn"
    }, [(item.status < 3) ? _c('div', {
      staticClass: "sai-join",
      on: {
        "click": function($event) {
          return _vm.goApply(item)
        }
      }
    }, [_vm._v("报名\n            ")]) : _vm._e(), _vm._v(" "), (_vm.hasHuiyiTrain(item)) ? _c('div', {
      staticClass: "sai-train",
      on: {
        "click": function($event) {
          return _vm.goHuiyiTrain(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.huiyiTrainButtonText(item)) + "\n            ")]) : _vm._e(), _vm._v(" "), (item.status != 1) ? _c('div', {
      staticClass: "sai-into",
      on: {
        "click": function($event) {
          return _vm.goActivity(item)
        }
      }
    }, [_vm._v("进入\n            ")]) : _vm._e()])])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.arrow) ? _c('div', {
    staticClass: "time-change1",
    on: {
      "click": function($event) {
        return _vm.timeChange(1)
      }
    }
  }) : _c('div', {
    staticClass: "time-change2",
    on: {
      "click": function($event) {
        return _vm.timeChange(2)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "2.4rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row4"
  }, [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'MyActivity'
      }),
      expression: "{name:'MyActivity'}"
    }],
    attrs: {
      "src": require("../../../assets/images/sai/bg-wodesaishi.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ChaSearchSai'
      }),
      expression: "{name:'ChaSearchSai'}"
    }],
    attrs: {
      "src": require("../../../assets/images/sai/bg-cehgnjichaxun.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: 7
        }
      }),
      expression: "{name:'NewsList',query:{cate_id:7}}"
    }],
    attrs: {
      "src": require("../../../assets/images/sai/bg-xiangguanwenjian.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('van-tabs', {
    staticClass: "tab-nav",
    staticStyle: {
      "background": "none",
      "margin-bottom": "20px"
    },
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onLevelChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "全部"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "全国比赛"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "其他比赛"
    }
  })], 1), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(month) {
    return (month.list.length > 0) ? _c('div', {
      staticClass: "sai-data-items"
    }, [_c('div', {
      staticClass: "flex-between sai-data-year"
    }, [_c('div', {
      staticClass: "data-times"
    }, [_vm._v(_vm._s(month.title))]), _vm._v(" "), _c('div', {
      staticClass: "flex-start gray-light",
      on: {
        "click": function($event) {
          return _vm.onShowMore(month)
        }
      }
    }, [_c('van-icon', {
      staticClass: "gray-light",
      attrs: {
        "name": month.showMore ? 'arrow-up' : 'arrow-down',
        "size": ".5rem"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!month.showMore),
        expression: "!month.showMore"
      }]
    }, [_vm._v("点击可了解更多")])], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (month.showMore),
        expression: "month.showMore"
      }],
      staticClass: "sai-items-box"
    }, _vm._l((month.list), function(item) {
      return _c('div', {
        staticClass: "sai-itmes"
      }, [_c('div', {
        staticClass: "items-top1"
      }, [_c('div', {
        staticClass: "train-items-top show-two-row",
        style: ('background-image: linear-gradient(to right, #' + item.color[0] + ' , #' + item.color[1] + ');')
      }, [(item.is_online == 1) ? _c('div', {
        staticClass: "sai-type-tip"
      }, [_vm._v("线上")]) : (item.is_online == 2) ? _c('div', {
        staticClass: "sai-type-tip offline"
      }, [_vm._v("线下")]) : _c('div', {
        staticClass: "sai-type-tip offline2"
      }, [_vm._v("线上线下结合")]), _vm._v(" "), _c('div', {
        staticClass: "train-items-top-city"
      }, [_vm._v(_vm._s(item.location))]), _vm._v(" "), _c('div', {
        staticClass: "train-items-top-time"
      }, [_vm._v(_vm._s(item.saidate_str) + " ~ " + _vm._s(item.saidate_end_str))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "text-align": "center",
          "margin-top": ".1rem"
        }
      }, [(item.status == 1) ? _c('span', {
        staticClass: "info-status-0"
      }, [_vm._v("未开始")]) : (item.status == 2) ? _c('span', {
        staticClass: "info-status-1"
      }, [_vm._v("正在报名")]) : (item.status == 3) ? _c('span', {
        staticClass: "info-status-0"
      }, [_vm._v("报名结束")]) : (item.status == 4) ? _c('span', {
        staticClass: "info-status-1"
      }, [_vm._v("正在比赛")]) : (item.status == 5) ? _c('span', {
        staticClass: "info-status-0"
      }, [_vm._v("已结束")]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "sai-info-box",
        staticStyle: {
          "flex": "1"
        }
      }, [_c('p', {
        staticClass: "sai-title show-two-row"
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (false) ? _c('div', {
        staticClass: "sai-info"
      }, [(item.status == 1) ? _c('span', {
        staticClass: "info-status-0"
      }, [_vm._v("·未开始")]) : (item.status == 2) ? _c('span', {
        staticClass: "info-status-1"
      }, [_vm._v("·正在报名")]) : (item.status == 3) ? _c('span', {
        staticClass: "info-status-0"
      }, [_vm._v("·报名结束")]) : (item.status == 4) ? _c('span', {
        staticClass: "info-status-1"
      }, [_vm._v("·正在比赛")]) : (item.status == 5) ? _c('span', {
        staticClass: "info-status-0"
      }, [_vm._v("·已结束")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "sai-info"
      }), _vm._v(" "), _c('div', {
        staticClass: "items-btn"
      }, [(item.status < 3) ? _c('div', {
        staticClass: "sai-join",
        on: {
          "click": function($event) {
            return _vm.goApply(item)
          }
        }
      }, [_vm._v("报名\n                ")]) : _vm._e(), _vm._v(" "), (_vm.hasHuiyiTrain(item)) ? _c('div', {
        staticClass: "sai-train",
        on: {
          "click": function($event) {
            return _vm.goHuiyiTrain(item)
          }
        }
      }, [_vm._v(_vm._s(_vm.huiyiTrainButtonText(item)) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.status != 1) ? _c('div', {
        staticClass: "sai-into",
        on: {
          "click": function($event) {
            return _vm.goActivity(item)
          }
        }
      }, [_vm._v("进入\n                ")]) : _vm._e()])])])
    }), 0)]) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.overlayShow,
      "lock-scroll": ""
    },
    on: {
      "click": function($event) {
        return _vm.timeChange(1)
      }
    }
  }), _vm._v(" "), (_vm.showWxShare) ? _c('div', {
    staticClass: "shareShow",
    on: {
      "click": function($event) {
        _vm.showWxShare = false
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.huiyiTrainSheetActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "select": _vm.onHuiyiTrainSheetSelect
    },
    model: {
      value: (_vm.huiyiTrainSheetShow),
      callback: function($$v) {
        _vm.huiyiTrainSheetShow = $$v
      },
      expression: "huiyiTrainSheetShow"
    }
  }), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '30%'
    }),
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.show_share_panel),
      callback: function($$v) {
        _vm.show_share_panel = $$v
      },
      expression: "show_share_panel"
    }
  }, [_c('div', {
    staticClass: "share-panel"
  }, [_c('div', {
    staticClass: "share-title"
  }, [_vm._v("请选择分享方式")]), _vm._v(" "), _c('div', {
    staticClass: "share-ul"
  }, [_c('div', {
    staticClass: "share-weixin",
    on: {
      "click": _vm.shareWeixinFriend
    }
  }, [_c('p', [_vm._v("微信好友")])]), _vm._v(" "), _c('div', {
    staticClass: "share-timeline",
    on: {
      "click": _vm.shareWeixinTimeLine
    }
  }, [_c('p', [_vm._v("朋友圈")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.copy_text),
      expression: "copy_text",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (function() {
        _vm.copySuccess();
        _vm.show_share_panel = false
      }),
      expression: "function(){copySuccess();show_share_panel=false }",
      arg: "success"
    }],
    staticClass: "share-copy"
  }, [_c('p', [_vm._v("复制链接")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("点击分享给好友")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ddb2fba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/SaiDateList.vue
// module id = 2381
// module chunks = 0